import * as yup from "yup";

export const orderScehema = yup.object({
  postalCode: yup.string().required("postal code required"),
  contactNum: yup.number().required("contactNum required"),
  city: yup.string().required("city  required"),
  deliveryAddress: yup.string().required("deliveryAddress required"),
  agree: yup.boolean().oneOf([true], "you should agree to terms and service"),
});
